import {
    Component,
    computed,
    CUSTOM_ELEMENTS_SCHEMA,
    effect,
    input,
    InputSignal,
    OnInit,
    output,
    OutputEmitterRef
} from '@angular/core';
import { ShSelectComponent } from '../../sh-select/sh-select.component';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { tap } from 'rxjs';
import { pageSizeOptions } from '@shs-digi-care-monorepo/interfaces';

@Component({
    selector: 'app-paginator',
    templateUrl: './paginator.component.html',
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [ShSelectComponent, FormsModule, ReactiveFormsModule]
})
export class PaginatorComponent implements OnInit {
    public pageSizeOptions: InputSignal<number[]> = input(pageSizeOptions);
    public pageSize: InputSignal<number> = input(10);
    public currentPage: InputSignal<number> = input(1);
    public totalItems: InputSignal<number> = input(0);
    public summary = input<string | null>(null);
    public pageChange: OutputEmitterRef<number> = output<number>();
    public pageSizeChange: OutputEmitterRef<number> = output<number>();

    protected pageSizeControl = new FormControl<number>(this.pageSize(), { nonNullable: true });

    protected Math = Math;

    constructor() {
        effect(() => {
            const size = this.pageSize();
            if (this.pageSizeControl.value !== size) {
                this.pageSizeControl.setValue(size, { emitEvent: false });
            }
        });
    }

    public pageSizeOptionsObjects = computed(() =>
        this.pageSizeOptions().map((option) => ({ label: option.toString(), value: option }))
    );

    public ngOnInit(): void {
        this.listenToPageSizeChanges();
    }

    protected goToPageEvent(event: Event): void {
        const target = event.currentTarget as HTMLElement & { currentPage?: number };
        const page = target.currentPage;
        if (page && !isNaN(page)) {
            this.goToPage(page);
        }
    }

    protected goToPage(page: number): void {
        this.pageChange.emit(page);
    }

    protected nextPage(): void {
        this.goToPage(this.currentPage() + 1);
    }

    protected previousPage(): void {
        this.goToPage(this.currentPage() - 1);
    }

    private listenToPageSizeChanges(): void {
        this.pageSizeControl.valueChanges
            .pipe(
                tap((newPageSize) => {
                    this.pageSizeChange.emit(Number(newPageSize));
                    this.pageChange.emit(1); // Reset to first page when page size changes
                })
            )
            .subscribe();
    }
}
